import React, { PureComponent, createRef } from 'react';
import { Card, Modal, Button as MaterialButton } from '@material-ui/core';
import { ClipLoader } from 'react-spinners';
import Photo from './Photo';
import { Button } from 'kangarootime-ui';
import './PhotoUpload.css';

export default class PhotoUpload extends PureComponent {
  constructor (props) {
    super(props);

    this.state = {
      isDragging: false
    };

    this.dropZoneRef = createRef();
    // used to prevent "leave" from firing when passing over child components
    this.dragCounter = 0;
  }

  get numberOfFiles () {
    return this.props.files.length || 0;
  }

  get estimatedFileSize () {
    const bytes = this.props.files.map(file => file.size);
    const byteSize = bytes.reduce((a, b) => b + a, 0);

    return (byteSize / Math.pow(1024, 2)).toFixed(2);
  }

  /**
   * if one or more of the provided files is over the upload limit (4.5mb)
   */
  get hasInvalidFile () {
    for (const file of this.props.files) {
      const { size } = file;
      const byteToMb = size / Math.pow(1024, 2);

      if (parseFloat(byteToMb) > 4.5) {
        return true;
      }
    }

    return false;
  }

  get uploadingFiles () {
    return this.props.uploading;
  }

  addEventListeners = () => {
    this.dropZoneRef.addEventListener('dragenter', this.handleDragEnter);
    this.dropZoneRef.addEventListener('dragleave', this.handleDragLeave);
    this.dropZoneRef.addEventListener('dragover', this.handleDragOver);
    this.dropZoneRef.addEventListener('drop', this.handleDrop);
  }

  removeEventListeners = () => {
    this.dropZoneRef.removeEventListener('dragenter', this.handleDragEnter);
    this.dropZoneRef.removeEventListener('dragleave', this.handleDragLeave);
    this.dropZoneRef.removeEventListener('dragover', this.handleDragOver);
    this.dropZoneRef.removeEventListener('drop', this.handleDrop);
  }

  handleDragEnter = event => {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter++;

    if (event.dataTransfer.items && event.dataTransfer.items.length > 0) {
      this.setState({ isDragging: true });
    }
  }

  handleDragLeave = event => {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter--;

    if (this.dragCounter > 0) {
      return;
    }

    this.setState({ isDragging: false });
  }

  handleDragOver = event => {
    event.preventDefault();
    event.stopPropagation();
  }

  handleDrop = event => {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ isDragging: false }, () => {
      if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
        const files = event.dataTransfer.files;
        this.props.handleFileSelection(files);

        event.dataTransfer.clearData();
        this.dragCounter = 0;
      }
    });
  }

  handleFileSelect = event => {
    event.preventDefault();
    event.stopPropagation();

    const files = event.target.files;

    if (files.length > 0) {
      this.props.handleFileSelection(files);
    }
  }

  handleModalClose = () => {
    this.removeEventListeners();
    this.props.onClose();
  }

  render () {
    const { isOpen, onClose, files, handleUpload } = this.props;
    const { isDragging } = this.state;

    return (
      <Modal open={isOpen} onClose={this.handleModalClose} onRendered={this.addEventListeners}>
        <div className='flex' style={{ justifyContent: 'center', alignItems: 'center', marginTop: 32 }}>
          <Card className='flex-columns' style={{ width: 540, height: 360 }}>
            <input type='file' ref={ref => { this.fileInputRef = ref; }} style={{ display: 'none' }} accept='image/*' multiple onChange={this.handleFileSelect} />
            <div
              ref={ref => { this.dropZoneRef = ref; }}
              className='dropzoneContainer'
              style={{ opacity: isDragging ? 0.95 : 1 }}
            >
              { isDragging
                ? <div className='dropzoneOverlayContainer'>
                  <div className='dropzoneOverlayTextContainer'>
                    <div>Drop File</div>
                  </div>
                </div>
                : null
              }
              { this.numberOfFiles === 0
                ? <div>
                  <span style={{ display: 'block', textAlign: 'center' }}>Drop here or </span>
                  <MaterialButton variant='outlined' component='span' onClick={() => this.fileInputRef.click()}>Select Files</MaterialButton>
                </div>
                : files.map((file, index) => <Photo key={index} file={file} removeFileFromUploadGroup={() => this.props.removePhotoFromUploadGroup(index)} />)
              }
            </div>
            <div style={{ margin: 8 }}>
              <span style={{ fontSize: 12, color: '#6B778C' }}>Estimated upload size: {this.estimatedFileSize} MB</span>
            </div>
            <div className='flex-rows' style={{ padding: 8, justifyContent: 'flex-end', alignItems: 'center' }}>
              <Button type='secondary' onClick={onClose}>
                Cancel
              </Button>
              <Button onClick={handleUpload} disabled={this.uploadingFiles || this.numberOfFiles === 0 || this.hasInvalidFile}>
                Upload {this.numberOfFiles} {this.numberOfFiles === 1 ? 'photo' : 'photos'}
              </Button>
              { this.uploadingFiles
                ? <ClipLoader
                  size={24}
                  color='#FF7CC3'
                />
                : null
              }
            </div>
          </Card>
        </div>
      </Modal>
    );
  }
}
